const Popup = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient id="borderGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#7D0F13', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#D71921', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect x="0.5" y="0.5" width="23" height="23" stroke="url(#borderGradient)" strokeWidth="1.67" fill="none" />
      <path d="M2.5 5.70605H21.5" className="stroke-ek-red" strokeWidth="1.231" strokeLinecap="round" />
      <path d="M2.5 10.5557H14.9609" className="stroke-ek-red" strokeWidth="1.231" strokeLinecap="round" />
      <path d="M2.5 15.3086H11.9609" className="stroke-ek-red" strokeWidth="1.231" strokeLinecap="round" />
      <path d="M15 15.3086H21.3965" className="stroke-ek-red" strokeWidth="1.231" strokeLinecap="round" />
      <path d="M18.1992 12.1685L18.1992 18.5649" className="stroke-ek-red" strokeWidth="1.231" strokeLinecap="round" />
    </svg>
  );
};

export default Popup;